/**
 * Phase 17 Plan 17-02 — API client for the 4 KPI Template endpoints under
 * `/api/kpi-templates`.
 *
 * All endpoints require `kpis.manage_templates` permission (Admin-only).
 */

import { api } from '@/lib/api/axios';
import { toApiError } from '@/lib/api/error';
import type {
  CreateKpiTemplateBody,
  KpiTemplate,
  UpdateKpiTemplateBody,
} from '@/types/kpi-template';

/** `GET /api/kpi-templates` — list all templates. */
export async function listKpiTemplatesRequest(): Promise<KpiTemplate[]> {
  try {
    const { data } = await api.get<KpiTemplate[]>('/api/kpi-templates');
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

/** `POST /api/kpi-templates` — create a new template (409 on duplicate name). */
export async function createKpiTemplateRequest(body: CreateKpiTemplateBody): Promise<KpiTemplate> {
  try {
    const { data } = await api.post<KpiTemplate>('/api/kpi-templates', body);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

/** `PUT /api/kpi-templates/:id` — update an existing template. */
export async function updateKpiTemplateRequest(
  id: number,
  body: UpdateKpiTemplateBody,
): Promise<KpiTemplate> {
  try {
    const { data } = await api.put<KpiTemplate>(`/api/kpi-templates/${String(id)}`, body);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

/** `DELETE /api/kpi-templates/:id` — delete a template (204 No Content). */
export async function deleteKpiTemplateRequest(id: number): Promise<undefined> {
  try {
    await api.delete(`/api/kpi-templates/${String(id)}`);
    return undefined;
  } catch (e) {
    throw toApiError(e);
  }
}
